export default __webpack_public_path__ + "static/media/financebeginner.506271dc.jpg";